const DEFAULT_TIMEZONE = 'America/New_York';

export default DEFAULT_TIMEZONE;
